var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4873 7.3875C13.4687 7.30691 13.4304 7.23217 13.3759 7.17C13.3214 7.10783 13.2523 7.06015 13.1748 7.03125L9.57477 5.68125L10.4873 1.1C10.5083 0.99388 10.4947 0.883829 10.4486 0.785976C10.4025 0.688123 10.3262 0.607614 10.231 0.556249C10.1349 0.505108 10.0245 0.487185 9.91714 0.505271C9.80975 0.523357 9.71136 0.576437 9.63727 0.656249L2.63727 8.15625C2.57991 8.21576 2.53841 8.28872 2.51657 8.36843C2.49473 8.44814 2.49325 8.53207 2.51227 8.6125C2.53184 8.69265 2.57047 8.76689 2.62487 8.82891C2.67928 8.89094 2.74785 8.93891 2.82477 8.96875L6.42477 10.3187L5.51227 14.9C5.49128 15.0061 5.50484 15.1162 5.55096 15.214C5.59707 15.3119 5.67332 15.3924 5.76852 15.4437C5.84028 15.48 5.9194 15.4992 5.99977 15.5C6.06769 15.5003 6.13494 15.4866 6.19731 15.4597C6.25969 15.4328 6.31584 15.3933 6.36227 15.3437L13.3623 7.84375C13.4196 7.78424 13.4611 7.71128 13.483 7.63157C13.5048 7.55186 13.5063 7.46793 13.4873 7.3875Z",
    fill: "#EAEAEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/lightning.ec04ed704960b3213527989a5334d7e3.svg";
export { ForwardRef as ReactComponent };